// extracted by mini-css-extract-plugin
export default {"container":"JL-z","topReviewHeading":"KL-z","criticalReview":"LL-z","favorableReview":"ML-z","vsSeparator":"NL-z"};